<template>
  <div class="settlement-center" v-if="newWithdraw">
    <div class="title-wrap">
      <!-- <div class="title-name">个人结算中心</div> -->
      <!-- <div class="tip-bind-card" v-if="!bankInfo.bank_card">
        <span>提现需要绑定银行卡</span>
        <span
          class="btn-bind btn"
          @click="$router.push({ name: 'settlementSet' })"
          >请前往绑定 ></span
        >
      </div> -->
      <div
        class="tip-bind-card"
        v-if="developerInfo.state == 0 || developerInfo.state == 3"
      >
        <span>成为迷你世界创作者，参与收益分成</span>
        <a
          :href="registerUrl"
          target="_blank"
          class="btn-bind btn"
          style="text-decoration: none"
          >前往了解 ></a
        >
      </div>
      <div class="tab-list">
        <div
          :class="[activeLabel == 1 ? 'income active' : 'income']"
          @click="changeLabel(1)"
        >
          <div class="income-content">我的收益</div>
        </div>
        <div
          :class="[activeLabel == 2 ? 'record active' : 'record']"
          @click="changeLabel(2)"
        >
          <div class="record-content">结算记录</div>
        </div>
      </div>
    </div>
    <personWithdrawCard v-if="activeLabel == 1"></personWithdrawCard>
    <IndexPageTable v-if="activeLabel == 2"></IndexPageTable>
  </div>
  <!--是否显示旧版本-->
  <div class="settlement-center" v-else>
    <div class="title-wrap">
      <div class="title-name">结算中心</div>
      <div class="tip-bind-card" v-if="!bankInfo.bank_card">
        <span>提现需要绑定银行卡</span>
        <span
          class="btn-bind btn"
          @click="$router.push({ name: 'settlementSet' })"
          >请前往绑定 ></span
        >
      </div>
      <div
        class="tip-bind-card"
        v-if="developerInfo.state == 0 || developerInfo.state == 3"
      >
        <span>成为迷你世界创作者，参与收益分成</span>
        <a
          :href="registerUrl"
          target="_blank"
          class="btn-bind btn"
          style="text-decoration: none"
          >前往了解 ></a
        >
      </div>
    </div>
    <div class="dialog-intro">
      <el-dialog
        title="收益改版说明"
        :visible.sync="dialogVisible"
        width="770px"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <!--第一步-->
        <div class="detail-content" v-if="step == 1">
          <div class="desc">{{ descText1 }}</div>
          <div class="desc">{{ descText2 }}</div>
          <div class="desc">
            {{ descText3 }}
            <span class="desc1">
              <a href="www.baidu.com" target="_blank">
                {{ descText4 }}
              </a>
            </span>
          </div>
          <div class="desc">{{ descText5 }}</div>
          <div class="wrapdraw-wrap">
            <div class="wrapdraw-box">
              <div class="content-wrap">
                <div class="content">
                  <img src="@/assets/images/money_logo.png" class="imgPic" />
                  <div class="desc">可提现金额</div>
                  <div class="mValue">
                    <span class="value1">888 </span>
                    <span class="bean">元</span>
                  </div>
                </div>
                <div class="bind">
                  <div class="button1">提现</div>
                </div>
              </div>
              <div class="intro">可提现余额门槛为100元</div>
            </div>
            <div class="wrapdraw-box">
              <div class="content-wrap">
                <div class="content">
                  <img src="@/assets/images/minibean.png" class="imgPic" />
                  <div class="desc">迷你豆</div>
                  <div class="mValue">
                    <span class="value1">888 </span>
                    <span class="bean">豆</span>
                  </div>
                </div>
                <!--迷你豆提现-->
                <div class="bind">
                  <div class="button1">提取到游戏</div>
                </div>
              </div>
              <div class="intro">每月额度100000</div>
            </div>
          </div>
          <div class="submit">
            <div class="button" @click="changStep">下一步</div>
          </div>
        </div>
        <!--第二步-->
        <div class="income-content" v-else>
          <div class="title">2022-01-01日前折算收益</div>
          <div class="content">
            <span class="mtitle">广告收入</span>
            <span class="value">{{ ad }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">贡献点收入</span>
            <span class="value">{{ contribution }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">迷你点折算收入</span>
            <span class="value">{{ minipoint }}元</span>
          </div>
          <div class="content">
            <span class="mtitle">其他收入</span>
            <span class="value">{{ other }}元</span>
          </div>
          <div class="conclusion-box">
            <div class="conclusion">合计</div>
            <div class="conclusion-value">{{ sumValue }}元</div>
          </div>
          <div class="conclusion-box">
            <div class="conclusion">迷你豆收入</div>
            <div class="conclusion-value">{{ sumMinibean }}</div>
          </div>
          <div class="sumbit" @click="submit">
            <el-button type="warning" size="medium">确认</el-button>
          </div>
          <div class="detail-desc">
            <span class="desc">
              结算明细统计1月1日前，广告、贡献点、迷你点、其他收入中未提现的全部收益，并根据兑换比例进行折算。详细请查看</span
            >
            <a
              href="https://mnweb.mini1.cn/activity/docs/settlement_proto_20210521.html"
              target="_blank"
              >《迷你平台结算规则说明》</a
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <WithdrawCard @refreshTable="refreshTable"></WithdrawCard>
    <IndexPageTable :isRefreshTable="isRefreshTable"></IndexPageTable>
  </div>
</template>

<script>
import WithdrawCard from './components/settlementCenter/withdrawCard';
import personWithdrawCard from './components/settlementCenter/personWithdrawCard.vue';
import IndexPageTable from './components/settlementCenter/indexPageTable';
import { mapState } from 'vuex';
import { fetchBillDetail, postNoticeFlag } from '@/api/income';
import { getKfzInfo } from '@/api/common';
// import { createRegisterUrl } from '@/utils';
// import { RegistryReferer } from '@/types';
export default {
  name: 'settlement',
  data() {
    return {
      registerUrl:
        'https://dev-wiki.mini1.cn/m/cyclopdeia?wikiMenuId=1634&wikiId=805', // createRegisterUrl(RegistryReferer.Settlement),
      isRefreshTable: false,
      activeLabel: 1,
      dialogVisible: true,
      newWithdraw: true,
      judgeBle: false,
      step: 1,
      userTxt: '开发者',
      sumMinibean: 0,
      conclusion_title: '',
      notice_flag: 0,
      descText1: '',
      descText2: '',
      descText3: '',
      descText5: '',
      descText4: '',
      ad: 0,
      minipoint: 0,
      other: 0,
      contribution: 0,
      sumValue: 0,
      req_time: 0,
      BillDeatil: {},
      ArrValue: [
        {
          title: '广告',
          value: 0,
        },
        {
          title: '贡献点',
          value: 0,
        },
        {
          title: '迷你点',
          value: 0,
        },
        {
          title: '其他收入',
          value: 0,
        },
      ],
    };
  },
  components: {
    WithdrawCard,
    IndexPageTable,
    personWithdrawCard,
  },
  computed: {
    ...mapState(['bankInfo', 'developerInfo', 'userInfo']),
  },
  mounted() {
    this.Report('view', 'PersonalSettlementPage');
    this.settleCentrShow();
    this.init();
    //判断是否需要弹出收益改版说明
    // this.judgeDialog();
    //获取历史账单明细
    //this.getBillDetail();
    //判断是否是427灰度测试
    let version = '';
    //判断是否是427版本
    if (this.userInfo.ver) {
      let ver = this.userInfo.ver.split('.');
      version =
        (parseInt(ver[0]) << 16) + (parseInt(ver[1]) << 8) + parseInt(ver[2]);
      if (version >= 68608) {
        this.userTxt = '开发者';
      } else {
        this.userTxt = '开发者';
      }
    }
  },
  methods: {
    init() {
      this.descText1 =
        '各位迷你世界的创作者你们好，为了方便创作者查看自己的收入，并将收入便捷提现到账。收益中心推出了全新的结算版本，针对结算中心和收益管理进行了改版。';
      this.descText2 =
        '各位创作者可以在结算中心-结算记录中查看自己的提现记录，在收益总览-收益明细中查看自己的收入记录。';
      this.descText3 =
        '除了更清晰的收支明细外，在结算中心-我的收益中，我们将推出全新的钱包管理能力，在本次更 新后，平台将对创作者的广告、贡献点、迷你点、其他收入统一折算成可提现余额，将迷你豆保 留不变。创作者在后续的提现过程中，只需在固定提现日期提现一次即可完成提现。迷你豆的提 现需要进行一次提现兑换。详细见';
      this.descText4 = '《收益改版公告》。';
      this.descText5 =
        '点击【下一步】，确认新版钱包折算后的可提现余额与迷你豆（如图片示例）。';
    },
    //判断是否需要弹出改版说明弹框
    judgeDialog() {
      this.fetchKfzInfo();
    },
    async fetchKfzInfo() {
      const res = await getKfzInfo();
      this.req_time = res.data.req_time * 1000;
      this.notice_flag = res.data.notice_flag;
      console.log(this.notice_flag);
      //设置上线时间
      let date1 = '2022-02-28 00:00:00';
      //表示不需要弹出----注册时间小于上线时间 没有看过弹框
      if (this.getTargetTime(date1) > this.req_time && this.notice_flag === 0) {
        this.newWithdraw = false;
        this.getBillDetail();
      } else {
        this.newWithdraw = true;
      }
    },
    //获取历史账单明细
    async getBillDetail() {
      const res = await fetchBillDetail();
      this.ad = res.data.ad;
      this.contribution = res.data.contribution;
      this.minipoint = res.data.minipoint;
      this.other = res.data.other;
      this.sumMinibean = res.data.minibean;
      this.sumMinibean = res.data.minibean;
      this.sumValue =
        res.data.ad +
        res.data.contribution +
        res.data.minipoint +
        res.data.other;
    },
    //获取指定时间的时间戳，也就是上线时间
    getTargetTime(t) {
      let d = t.split(' ')[0],
        h = t.split(' ')[1],
        date = new Date();
      date.setYear(d.split('-')[0]);
      date.setMonth(d.split('-')[1] - 1);
      date.setDate(d.split('-')[2]);
      date.setHours(h.split(':')[0]);
      date.setMinutes(h.split(':')[1]);
      date.setSeconds(h.split(':')[2]);
      return date.getTime();
    },
    submit() {
      this.newWithdraw = true;
      this.setNoticeFlag();
    },
    //记录已看过弹框
    async setNoticeFlag() {
      try {
        await postNoticeFlag();
      } catch (err) {
        console.log(err);
      }
    },
    refreshTable(val) {
      if (val) {
        this.isRefreshTable = true;
      }
    },
    changeLabel(index) {
      this.activeLabel = index;
    },
    changStep() {
      this.step = 2;
    },
    //结算中心曝光埋点
    settleCentrShow() {
      this.$log('settlement_center_show', 85431, { v7: 1 });
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.settlement-center {
  // margin-top: 13px;
  .title-wrap {
    font-size: 24px;
    color: #595959;
    // padding-bottom: 15px;
    margin-bottom: 8px;
    .title-name {
      margin-bottom: 10px;
    }
    .tip-bind-card {
      font-size: 14px;
      color: #8c8c8c;
      margin-top: 8px;
      .btn-bind {
        color: #2b6ddf;
        margin-left: 22px;
      }
    }
    .tab-list {
      //margin-top: 10px;
      display: flex;
      color: #595959;
      font-size: 18px;
      //margin-left: 32px;
      border-bottom: 1px solid rgba(217, 217, 217, 1);
      .income {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        padding-bottom: 16px;
        margin-right: 19px;
        //margin-left: 19px;
        cursor: pointer;
        .income-content {
          //margin-left: 19px;
          line-height: 26px;
        }
      }
      .income.active {
        border-bottom: 4px solid #fd9b21;
        position: relative;
        color: #fd9b21;
        &:before {
          display: block;
          content: '';
          width: 0;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent $--color-primary transparent;
          position: absolute;
          left: 50%;
          margin-left: -2px;
          bottom: 0;
        }
      }
      .record {
        padding-bottom: 16px;
        font-size: 20px;
        cursor: pointer;
        line-height: 26px;
        //-webkit-background-clip: text;
        //-webkit-text-fill-color: transparent;
      }
      .record.active {
        border-bottom: 4px solid #fd9b21;
        position: relative;
        color: #fd9b21;
        &:before {
          display: block;
          content: '';
          width: 0;
          border-width: 4px;
          border-style: solid;
          border-color: transparent transparent $--color-primary transparent;
          position: absolute;
          left: 50%;
          margin-left: -2px;
          bottom: 0;
        }
      }
    }
  }
  .dialog-intro {
    ::v-deep.el-dialog__wrapper {
      .el-dialog__header {
        text-align: center;
        padding-top: 40px;
        color: #262626;
        font-size: 24px;
        padding-bottom: 0;
      }
      .el-dialog__body {
        padding: 0;
      }
      .detail-content {
        color: #262626;
        margin: 20px 41px 21px 41px;
        .title {
          font-size: 18px;
          color: #262626;
          font-weight: 600;
        }
        .imgSrc {
          margin-top: 15px;
          img {
            width: 380px;
            height: 130px;
          }
        }
        .wrapdraw-wrap {
          margin-top: 9px;
        }
        .wrapdraw-box {
          margin-bottom: 24px;
          margin-top: 12px;
          padding: 13px 42px 12px 28px;
          border: 1px solid #e8edf7;
          background: #fcfdff;
          border-radius: 4px;
          font-size: 16px;
          .content-wrap {
            display: flex;
            align-items: center;
            .content {
              display: flex;
              padding-top: 0px;
              flex: 1;
              .desc {
                padding-top: 12px;
                margin-left: 14px;
                font-size: 20px;
                color: #000000;
              }
              .imgPic {
                height: 52px;
                padding-top: 16px;
                width: 36px;
              }
              .el-tooltip {
                margin-top: 9px;
                margin-right: 18px;
              }
              .mValue {
                margin-left: 10px;
                color: #fd9b21;
                display: flex;
                .value1 {
                  font-size: 32px;
                }
                .bean {
                  font-size: 16px;
                  display: flex;
                  align-items: flex-end;
                  padding-bottom: 12px;
                  margin-left: 6px;
                }
              }
            }
            .bind {
              margin-top: 16px;
              //margin-bottom: 28px;
              padding-top: 4px;
              padding-bottom: 6px;
              text-align: center;
              color: #fd9b21;
              font-size: 18px;
              width: 134px;
              height: 34px;
              background: #fffaed;
              border-radius: 4px;
              border: 1px solid #ffc973;
            }
          }

          .intro {
            margin-left: 50px;
            margin-top: -14px;
            font-size: 14px;
            color: #bfbfbf;
            line-height: 28px;
          }
        }
        .desc {
          font-size: 16px;
          color: #262626;
          line-height: 32px;
          .desc1 {
            color: #2b6ddf;
            a {
              text-decoration: none;
              color: #2b6ddf;
            }
          }
        }
        .content {
          display: flex;
          font-size: 16px;
          padding-top: 8px;
          .mtitle {
            display: flex;
            flex: 1;
          }
        }
        .submit {
          margin-top: 52px;
          display: flex;
          justify-content: center;
          padding-bottom: 42px;
          .button {
            height: 46px;
            background: #fd9b21;

            border-radius: 8px;
            color: #ffffff;
            font-size: 20px;
            cursor: pointer;
            padding: 10px 50px 8px 50px;
          }
        }
      }
      .income-content {
        color: #262626;
        margin: 32px 129px 24px 119px;
        .title {
          color: #262626;
          line-height: 32px;
          font-size: 24px;
          margin-bottom: 24px;
        }
        .content {
          display: flex;
          margin-bottom: 14px;
          font-size: 16px;
          color: #595959;
          .mtitle {
            display: flex;
            flex: 1;
          }
        }
        .conclusion-box {
          margin-top: 14px;
          font-size: 24px;
          color: #262626;
          display: flex;
          .conclusion {
            display: flex;
            flex: 1;
          }
        }
        .sumbit {
          margin-top: 82px;
          text-align: center;
          //padding-bottom: 20px;
          //color: #262626;
          .el-button--medium {
            padding: 10px 60px 8px 60px;
            color: #ffffff;
            font-size: 20px;
          }
        }
        .detail-desc {
          margin-top: 119px;
          text-align: center;
          .desc {
            font-size: 16px;
          }
          a {
            text-decoration: none;
            font-size: 16px;
            color: #2b6ddf;
            //padding-bottom: 24px;
          }
        }
        // .desc {
        //   text-align: center;
        //   padding-bottom: 24px;
        //   a {
        //     text-decoration: none;
        //     color: #2b6ddf;
        //     font-size: 16px;
        //     cursor: pointer;
        //   }
        // }
      }
    }
  }
  .btn {
    cursor: pointer;
    &:hover {
      filter: brightness(105%);
    }
  }
}
</style>
